<script>
  export let data;

  $: label = data.label;
</script>

<div class="cluster-node">
  <span class="cluster-label" title={label}>{@html label}</span>
</div>

<style>
  .cluster-node {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    border: 2px dashed #8d8d8d;
    border-radius: 8px;
    background: rgba(141, 141, 141, 0.08);
    position: relative;
  }

  .cluster-label {
    position: absolute;
    top: 6px;
    left: 12px;
    font-size: 0.875rem;
    font-weight: 600;
    color: #525252;
    white-space: nowrap;
  }
</style>
